import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

export interface EmailVerificationDialogData {
  email: string;
}

@Component({
  selector: 'app-email-verification-popup',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule
  ],
  template: `
    <h2 mat-dialog-title>Check your email on this device</h2>
    <button 
      mat-icon-button 
      class="close-button" 
      (click)="onClose()"
      aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
    
    <mat-dialog-content>
      <div class="dialog-content">
        <p class="dialog-message">
          Click the link we sent to <strong>{{ data.email }}</strong> to log in.
        </p>
        
        <div class="email-icon">
          <mat-icon class="large-icon">email</mat-icon>
        </div>
      </div>
    </mat-dialog-content>
    
    <mat-dialog-actions align="center">
      <button 
        mat-flat-button 
        color="primary"
        class="resend-button" 
        (click)="onResendEmail()">
        Resend email
      </button>
    </mat-dialog-actions>
  `,
  styles: [`
    .close-button {
      position: absolute;
      top: 8px;
      right: 8px;
      color: var(--mat-sys-on-surface-variant) !important;
      background: transparent !important;
    }

    .close-button:hover {
      color: var(--mat-sys-on-surface) !important;
      background: var(--mat-sys-surface-variant) !important;
    }

    .dialog-content {
      text-align: center;
      padding: 16px 0;
    }

    .dialog-message {
      font-size: 16px;
      color: var(--mat-sys-on-surface-variant);
      margin: 0 0 32px 0;
      line-height: 1.5;
    }

    .email-icon {
      display: flex;
      justify-content: center;
      margin: 32px 0;
    }

    .large-icon {
      font-size: 80px !important;
      width: 80px !important;
      height: 80px !important;
      color: var(--mat-sys-primary) !important;
    }

    .resend-button {
      min-width: 200px !important;
    }
  `]
})
export class EmailVerificationPopupComponent {
  constructor(
    public dialogRef: MatDialogRef<EmailVerificationPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EmailVerificationDialogData
  ) {}

  onClose(): void {
    this.dialogRef.close();
  }

  onChooseAnotherMethod(): void {
    this.dialogRef.close('choose-another-method');
  }

  onResendEmail(): void {
    this.dialogRef.close('resend-email');
  }
}
